import { authFetch } from "./api";


const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

/**
 * Получить финансы по заказу
 */
export const getOrderFinanceByOrderId = async (orderId) => {
  const res = await authFetch(
    `${BASE_URL}/api/order-finances/?ordering=-id&order=${orderId}`
  );

  if (!res.ok) {
    throw new Error("Ошибка загрузки финансов");
  }

  const data = await res.json();
  return data[0] || null;
};
